(function () {
  function getVisibleItems(track) {
    return Array.from(track.children).filter(function (el) {
      return el.hasAttribute('data-media-id') && !el.classList.contains('gallery-media-hidden');
    });
  }

  function scrollToItem(track, item, behavior) {
    if (!item) return;
    track.scrollTo({ left: item.offsetLeft, behavior: behavior || 'smooth' });
  }

  function setCurrentMediaId(root, mediaId) {
    if (!window.Alpine || !window.Alpine.$data) return;
    try {
      var data = window.Alpine.$data(root);
      if (data && data.currentMediaId !== mediaId) {
        data.currentMediaId = mediaId;
      }
    } catch (e) {
      // Alpine not attached to this root (yet) - ignore.
    }
  }

  function initTrack(track) {
    var root = track.closest('[data-product-root]');
    var currentItem = null;

    function updateCurrentItem(item) {
      if (!item) return;
      currentItem = item;
      if (root) {
        setCurrentMediaId(root, Number(item.getAttribute('data-media-id')));
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            updateCurrentItem(entry.target);
          }
        });
      },
      { root: track, threshold: [0.5] }
    );

    Array.from(track.children).forEach(function (item) {
      if (item.hasAttribute('data-media-id')) observer.observe(item);
    });

    function goDirection(direction) {
      var visible = getVisibleItems(track);
      if (!visible.length) return;
      var index = currentItem ? visible.indexOf(currentItem) : -1;
      if (index === -1) index = 0;
      var step = direction === 'prev' ? -1 : 1;
      var targetIndex = (index + step + visible.length) % visible.length;
      var target = visible[targetIndex];
      updateCurrentItem(target);
      scrollToItem(track, target);
    }

    if (root) {
      root.querySelectorAll('[data-mobile-gallery-arrow]').forEach(function (btn) {
        if (btn.closest('[data-product-root]') !== root) return;
        btn.addEventListener('click', function () {
          goDirection(btn.getAttribute('data-mobile-gallery-arrow'));
        });
      });

      // A direct thumbnail tap already sets currentMediaId via Alpine; also
      // scroll this track to match so the main image and thumbnail row
      // never disagree about which media is showing.
      root.addEventListener('click', function (event) {
        var thumbnail = event.target.closest('.media-thumbnail');
        if (!thumbnail) return;
        var thumbItem = thumbnail.closest('[data-media-id]');
        if (!thumbItem) return;
        var mediaId = thumbItem.getAttribute('data-media-id');
        var target = track.querySelector('[data-media-id="' + mediaId + '"]');
        if (target) {
          updateCurrentItem(target);
          scrollToItem(track, target);
        }
      });

      document.addEventListener('theme:variant:change', function (event) {
        if (!event.detail || event.detail.productRootEl !== root) return;
        // Wait a tick so gallery-variant-filter.js's own listener on this
        // same event (registered earlier) has already toggled
        // gallery-media-hidden before we check it.
        requestAnimationFrame(function () {
          if (currentItem && currentItem.classList.contains('gallery-media-hidden')) {
            var visible = getVisibleItems(track);
            if (visible.length) {
              updateCurrentItem(visible[0]);
              scrollToItem(track, visible[0], 'auto');
            }
          }
        });
      });
    }

    var initialVisible = getVisibleItems(track);
    if (initialVisible.length) {
      updateCurrentItem(initialVisible[0]);
      scrollToItem(track, initialVisible[0], 'auto');
    }
  }

  document.querySelectorAll('[data-mobile-gallery-track]').forEach(initTrack);
})();
